import { takeLatest, put, call, select } from 'redux-saga/effects';
import { initialize, reset } from 'redux-form';

import * as act from '../../actions';
import * as actNotif from '../../actions/notifications';
import * as actCategoryHub from '../../actions/businessLibrary/category';
import * as categoryHubConstant from '../../actions/businessLibrary/category/constants';
import { showPageLoadingSpinner } from '../../actions/loadingSpinner';

import * as apiCategoryHub from '../../api/businessLibrary/category';
import * as apiItemsHub from '../../api/businessLibrary/items';
import { assertErrorHasMessage } from '../../utils/assert';

const getCategoryHubState = (state) => state.businessLibrary.categoryHub;

const CATEGORY_SUCCESSFULLY_CREATED_MESSAGE = 'Category successfully created.';
const CATEGORY_SUCCESSFULLY_UPDATE_MESSAGE =
  'Category was successfully updated.';
const CATEGORY_SUCCESSFULLY_DELETE_MESSAGE =
  'Category was successfully removed.';
function* fillFormCategoryDetail(category) {
  const formCategoryDetail = {
    id: category.id,
    name: category.name,
  };
  yield put(initialize('categoryHub', formCategoryDetail));
}

function* fillFormAssignToItem(request) {
  const {
    payload: { category },
  } = request;
  const form = {
    id: category.id,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    business_level_item_ids: category.business_level_item_ids,
  };
  yield put(initialize('assignToItem', form));
}

export function* pageRequest() {
  yield put(actCategoryHub.setListCategories([]));
  yield put(showPageLoadingSpinner(true));
  yield put(act.showProgressBar());
  yield put(actCategoryHub.setCategoryDetail(null));
  yield put(actCategoryHub.closeRightColumn());
  yield put(actCategoryHub.setEventAsyncJob(null));
  try {
    yield put(
      actCategoryHub.categoriesRequest({
        page: 0,
        size: 50,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        with_uncategorized: false,
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* categoriesRequest(request) {
  const {
    payload: { params, previousCategories },
  } = request;
  try {
    yield put(act.showProgressBar());
    if (params && params.keyword) {
      const response = yield call(
        apiCategoryHub.getCategoriesWithUncategorized,
        params
      );
      yield put(actCategoryHub.setListCategories(response.data.results));
      yield put(
        actCategoryHub.setMetaCategories({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_counts: response.data.total_count,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_pages: response.data.total_pages - 1,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          current_page: 1,
        })
      );
    } else {
      params.with_uncategorized = false;
      const responseCategory = yield call(
        apiCategoryHub.getCategoriesWithUncategorized,
        params
      );

      let categories;
      if (previousCategories) {
        categories = previousCategories.concat(responseCategory.data.results);
      } else {
        categories = responseCategory.data.results;
      }
      yield put(actCategoryHub.setListCategories(categories));
      yield put(
        actCategoryHub.setMetaCategories({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_pages: responseCategory.data.total_pages - 1,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_counts: responseCategory.data.total_count,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          current_page: params.page,
        })
      );
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* onClickCreateCategory() {
  yield put(actCategoryHub.setCategoryDetail(null));
  yield call(fillFormCategoryDetail, { id: null, name: null });
  yield put(actCategoryHub.openRightColumn());
}

export function* onClickCancel() {
  yield put(actCategoryHub.setCategoryDetail(null));
  yield call(fillFormCategoryDetail, { id: null, name: null });
  yield put(actCategoryHub.closeRightColumn());
}

export function* createCategory(request) {
  const {
    payload: { data },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actCategoryHub.isSubmittingForm(true));
    yield put(
      actCategoryHub.setEventAsyncJob(
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_CREATE_CHANNEL
      )
    );
    yield call(apiCategoryHub.createCategory, {
      name: data.name,
    });
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actCategoryHub.isSubmittingForm(false));
    yield put(actNotif.error(err.message));
  }
}

export function* updateCategory(request) {
  const {
    payload: { id, data, previousCategories },
  } = request;
  const keyword = data.name;
  try {
    yield put(act.showProgressBar());
    yield put(actCategoryHub.isSubmittingForm(true));
    const categories: any[] = [];
    let categoryExisted = false;
    previousCategories.forEach((category) => {
      if (category.id === id) {
        categories.push(data);
      } else if (keyword !== category.name) {
        categories.push(category);
      } else {
        categoryExisted = true;
      }
    });
    if (categoryExisted) {
      yield put(actNotif.error('The name of the Category must be unique'));
    } else {
      yield put(
        actCategoryHub.setEventAsyncJob(
          categoryHubConstant.LIBRARY_CATEGORIES_HUB_UPDATE_CHANNEL
        )
      );
      yield call(apiCategoryHub.updateCategory, id, data);
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actCategoryHub.isSubmittingForm(false));
    yield put(actNotif.error(error.message));
  }
}

export function* onClickAssignToItem(request) {
  const {
    payload: { category },
  } = request;
  yield put(act.showProgressBar());
  try {
    const resItems = yield call(apiItemsHub.getItemsHub, { page: 0, size: 50 });
    const categoryDetail = yield call(
      apiCategoryHub.getCategoryDetail,
      category.id
    );
    const items = resItems.data;
    if (items.results) {
      yield put(
        actCategoryHub.assignToItemSetMeta({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_pages: items.total_pages - 1,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          total_counts: items.total_count,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          current_page: 0,
        })
      );
      yield put(actCategoryHub.assignToItemFillForm(categoryDetail.data));
      yield put(actCategoryHub.setCategoryDetail(categoryDetail.data));
      yield put(actCategoryHub.assignToItemSetItems(items.results));
    }
    yield put(actCategoryHub.showAssignToItemModal());
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* assignToItemGetItems(request) {
  const {
    payload: { params, previousItems },
  } = request;
  try {
    yield put(act.showProgressBar());
    if (params && params.keyword) {
      const resItems = yield call(apiItemsHub.getItemsHub, params);
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { results, total_pages, total_count } = resItems.data;

      if (results) {
        yield put(actCategoryHub.assignToItemSetItems(results));
        yield put(
          actCategoryHub.assignToItemSetMeta({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            total_pages: total_pages - 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            total_count,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            current_page: 0,
          })
        );
      } else if (!resItems.data.total_count) {
        yield put(actCategoryHub.assignToItemSetItems([]));
      }
    } else {
      const resItems = yield call(apiItemsHub.getItemsHub, params);
      if (resItems.data.results) {
        yield put(
          actCategoryHub.assignToItemSetMeta({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            total_pages: resItems.data.total_pages - 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            total_count: resItems.data.total_count,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            current_page: params.page,
          })
        );
        const items = previousItems.concat(resItems.data.results);
        yield put(actCategoryHub.assignToItemSetItems(items));
      }
    }
    yield put(actCategoryHub.showAssignToItemModal());
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* submitAssignToItem(request) {
  const {
    payload: { data, categoryId },
  } = request;
  try {
    yield put(act.showProgressBar());
    yield put(actCategoryHub.hideAssignToItemModal());
    yield put(
      actCategoryHub.setEventAsyncJob(
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_APPLY_TO_ITEMS_CHANNEL
      )
    );
    yield call(apiCategoryHub.assignCategoryToItem, categoryId, data);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* onClickRow(request) {
  const {
    payload: { category },
  } = request;
  try {
    yield put(act.showProgressBar());
    const categoryDetail = yield call(
      apiCategoryHub.getCategoryDetail,
      category.id
    );
    const categoryDetailInfo = categoryDetail.data;

    yield put(actCategoryHub.setCategoryDetail(categoryDetailInfo));
    yield call(fillFormCategoryDetail, categoryDetailInfo);
    yield put(actCategoryHub.openRightColumn());
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* requestDeleteCategory(request) {
  const {
    payload: { deletedCategory },
  } = request;
  yield put(actCategoryHub.setDeletedCategory(deletedCategory));
  yield put(actCategoryHub.showDeleteModal());
}

export function* deleteCategory(request) {
  const {
    payload: { id },
  } = request;
  yield put(act.showProgressBar());
  try {
    yield put(actCategoryHub.isSubmittingForm(true));
    yield put(
      actCategoryHub.setEventAsyncJob(
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_DELETE_CHANNEL
      )
    );
    yield call(apiCategoryHub.deleteCategory, id);
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actCategoryHub.isSubmittingForm(false));
    yield put(actNotif.error(error.message));
  }
}

export function* handleSuccessAsyncJob(request) {
  const {
    payload: { resourceId },
  } = request;
  try {
    const { categories, eventAsyncJob } = yield select(getCategoryHubState);
    let newCategories;
    if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_DELETE_CHANNEL
    ) {
      newCategories = categories.filter(
        (category) => category.id !== resourceId
      );
      yield put(actCategoryHub.setCategoryDetail(null));
      yield put(actCategoryHub.setDeletedCategory(null));
      yield put(actCategoryHub.hideDeleteModal());
      yield put(actCategoryHub.closeRightColumn());
      yield put(reset('categoryHub'));
      yield put(actNotif.success(CATEGORY_SUCCESSFULLY_DELETE_MESSAGE));
    } else if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_CREATE_CHANNEL
    ) {
      const respCategoryDetail = yield call(
        apiCategoryHub.getCategoryDetail,
        resourceId
      );
      newCategories = [...categories];
      newCategories.unshift(respCategoryDetail.data);
      yield put(actCategoryHub.setCategoryDetail(respCategoryDetail.data));
      yield call(fillFormCategoryDetail, respCategoryDetail.data);
      yield put(actNotif.success(CATEGORY_SUCCESSFULLY_CREATED_MESSAGE));
    } else if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_APPLY_TO_ITEMS_CHANNEL
    ) {
      yield put(
        actCategoryHub.categoriesRequest({
          page: 0,
          size: 50,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          with_uncategorized: false,
        })
      );
      yield put(actCategoryHub.setCategoryDetail(null));
      yield put(actCategoryHub.closeRightColumn());
      yield put(actNotif.success('Successfully move selected items.'));
    } else if (
      eventAsyncJob &&
      eventAsyncJob.channelName ===
        categoryHubConstant.LIBRARY_CATEGORIES_HUB_UPDATE_CHANNEL
    ) {
      const respCategoryDetail = yield call(
        apiCategoryHub.getCategoryDetail,
        resourceId
      );
      newCategories = categories.map((category) =>
        category.id === resourceId ? respCategoryDetail.data : category
      );
      yield put(actCategoryHub.setCategoryDetail(respCategoryDetail.data));
      yield call(fillFormCategoryDetail, respCategoryDetail.data);
      yield put(actNotif.success(CATEGORY_SUCCESSFULLY_UPDATE_MESSAGE));
    }
    yield put(actCategoryHub.setListCategories(newCategories));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actCategoryHub.setEventAsyncJob(null));
    yield put(act.hideProgressBar());
    yield put(actCategoryHub.isSubmittingForm(false));
  }
}

export function* handleFailedAsyncJob(request) {
  const {
    payload: { errorMessage },
  } = request;
  yield put(actCategoryHub.setEventAsyncJob(null));
  yield put(actCategoryHub.isSubmittingForm(false));
  yield put(actNotif.error(errorMessage || 'failed process category'));
}

export default function* saga() {
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_PAGE_REQUEST,
    pageRequest
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_LIST_REQUEST,
    categoriesRequest
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ON_CLICK_CREATE_CATEGORY,
    onClickCreateCategory
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ON_CLICK_CANCEL,
    onClickCancel
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_CREATE,
    createCategory
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_UPDATE,
    updateCategory
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ON_CLICK_ASSIGN_TO_ITEM,
    onClickAssignToItem
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_FILL_FORM,
    fillFormAssignToItem
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
    assignToItemGetItems
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_SUBMIT_ASSIGN_TO_ITEM,
    submitAssignToItem
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_ON_CLICK_ROW,
    onClickRow
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY_REQUEST,
    requestDeleteCategory
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY,
    deleteCategory
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_HANDLE_SUCCESS_ASYNC_JOB,
    handleSuccessAsyncJob
  );
  yield takeLatest(
    categoryHubConstant.LIBRARY_CATEGORIES_HUB_HANDLE_FAILED_ASYNC_JOB,
    handleFailedAsyncJob
  );
}
